import React, { useEffect, useRef, useState } from 'react'
import {
  Maximize as MaximizeIcon,
  Minimize as MinimizeIcon,
} from 'react-feather'
import L from 'leaflet'
import { isEmpty } from 'lodash'
import { Box, Button } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import helpers from 'helpers'

import useStyles from './styles'
import theme from 'theme'

const ReactLeaflet = ({ markers = [] }) => {
  const [fullscreen, setFullscreen] = useState(false)

  const classes = useStyles()

  const mapRef = useRef(null)
  const btnRef = useRef(null)

  const { getProportionalRadius } = helpers.leaflet

  useEffect(() => {
    if (mapRef.current && !mapRef.current._leaflet_id) {
      const map = L.map(mapRef.current, {
        center: [20, 0],
        zoom: 2,
      })

      L.tileLayer(
        'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
        {
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
          subdomains: 'abcd',
          maxZoom: 20,
        },
      ).addTo(map)

      if (!isEmpty(markers)) {
        const minQ = Math.min(...markers.map((m) => m.quantity))
        const maxQ = Math.max(...markers.map((m) => m.quantity))

        markers.forEach((marker) => {
          const radius = getProportionalRadius(marker.quantity, minQ, maxQ)
          const circle = L.circleMarker(marker.coords, {
            radius,
            color: theme.palette.primary.hover,
            fillColor: theme.palette.primary.hover,
            fillOpacity: 0.5,
          }).addTo(map)
          circle.bindTooltip(`${marker.city} (${marker.quantity})`)
        })
      }
    }

    if (btnRef.current) btnRef.current.onclick = handleFullscreen
    document.addEventListener('fullscreenchange', handleFsChange)

    return () => {
      if (mapRef.current && mapRef.current._leaflet_id)
        mapRef.current._leaflet_id = null

      document.removeEventListener('fullscreenchange', handleFsChange)
    }
  }, [])

  const handleFsChange = () => setFullscreen(!!document.fullscreenElement)

  const handleFullscreen = () => {
    if (!document.fullscreenElement) mapRef.current.requestFullscreen()
    else document.exitFullscreen()
  }

  const FullScreenIcon = fullscreen ? MinimizeIcon : MaximizeIcon

  return (
    <Box
      position="relative"
      ref={mapRef}
      className={classes.mapContainer}
      id="shared-map"
    >
      <Button ref={btnRef} variant="contained" className={classes.button}>
        <FullScreenIcon strokeWidth={2.5} />
      </Button>
    </Box>
  )
}

const BaseLeaflet = ({ isLoading = false, markers = [] }) => {
  return isLoading ? (
    <Skeleton width="100%" height="100%" variant="rect" />
  ) : (
    <ReactLeaflet markers={markers} />
  )
}

export default BaseLeaflet
